import { create } from 'zustand';
import { User } from '../models/all';

interface UserState {
  user: User | null;
  isAuthorized: boolean;
  setUser: (user: User | null) => void;
  setIsAuthorized: (authorized: boolean) => void;
}

export const useUserStore = create<UserState>((set: (partial: Partial<UserState>) => void) => ({
  user: null,
  isAuthorized: false,
  setUser: (user: User | null) => set({ user }),
  setIsAuthorized: (authorized: boolean) => set({ isAuthorized: authorized }),
}));
